export const columns = [
  {
    title: "项目名称",
    width: 300,
    dataIndex: "projectName",
    key: "projectName",
  },
  {
    title: "项目状态",
    width: 100,
    dataIndex: "projectStatusName",
    key: "projectStatusName",
  },
  {
    title: "项目类型",
    width: 200,
    dataIndex: "projectTypeName",
    key: "projectTypeName",
  },
  {
    title: "业主名称",
    width: 200,
    dataIndex: "companyName",
    key: "companyName",
  },
  {
    title: "项目负责人",
    width: 100,
    dataIndex: "projectLeaderName",
    key: "projectLeaderName",
  },
];
